/**
 * Separator between items in a list.
 * It can be passed to the `List` component as the `separator` prop.
 */
export function ListSeparator() {
    return <div className="my-4 border-b" />;
}
